module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBd.woff2?v=d14b188281d1158ac701e630697ce443";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBd.woff2
// module id = 676
// module chunks = 0